import './vice/index.css';

window.nn.registerModule('verzuimverzekeringDualStream', (el) => {
  el.innerHTML = require('./vice/index.tpl.html');

  const script = document.createElement('script');
  script.src = 'https://players.brightcove.net/3879528199001/72nneLxQC_default/index.min.js';
  script.type = 'text/javascript';
  document.head.appendChild(script);

  script.onload = () => {
    import(/* webpackChunkName: "vice" */ './vice');
  };
});
